import { createSelector } from 'reselect'

import { NAME } from './reducer'

const byIdSelector = state => state[NAME].byId
const allKeysSelector = state => state[NAME].allKeys

export const getLayerById = createSelector([byIdSelector], byId => id =>
  byId[id] || {}
)

export const getAILayers = createSelector(
  [getLayerById, allKeysSelector],
  (byId, allKeys) => allKeys.map(byId)
)
